import React, { useState } from 'react';
import Modal from 'react-modal';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { X } from 'lucide-react';

Modal.setAppElement('#root');

export default function WidgetCustomizer({ isOpen, onClose, onCreateWidget }) {
  const [widget, setWidget] = useState({
    title: '',
    type: 'metric_card',
    dataSource: 'tickets',
    config: {
      metric: 'count',
      groupBy: '',
      filters: {},
    },
  });

  const handleCreate = () => {
    if (!widget.title.trim()) {
      alert('Título é obrigatório');
      return;
    }
    
    onCreateWidget({
      ...widget,
      defaultPosition: { x: 0, y: 0, w: 6, h: 4 },
    });
    
    // Reset
    setWidget({
      title: '',
      type: 'metric_card',
      dataSource: 'tickets',
      config: { metric: 'count', groupBy: '', filters: {} },
    });
    
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      className="modal-content max-w-2xl mx-auto mt-20 bg-white rounded-lg shadow-xl p-6"
      overlayClassName="modal-overlay fixed inset-0 bg-black bg-opacity-50 flex items-start justify-center overflow-y-auto"
    >
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-2xl font-semibold text-slate-900">Criar Widget Personalizado</h2>
        <button onClick={onClose} className="text-slate-400 hover:text-slate-600">
          <X className="w-6 h-6" />
        </button>
      </div>

      <div className="space-y-4">
        <div>
          <Label>Título do Widget *</Label>
          <Input
            value={widget.title}
            onChange={(e) => setWidget({ ...widget, title: e.target.value })}
            placeholder="Ex: Total de Vendas"
          />
        </div>

        <div>
          <Label>Tipo de Visualização *</Label>
          <Select value={widget.type} onValueChange={(v) => setWidget({ ...widget, type: v })}>
            <SelectTrigger>
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="metric_card">📊 Card de Métrica</SelectItem>
              <SelectItem value="bar_chart">📈 Gráfico de Barras</SelectItem>
              <SelectItem value="pie_chart">🥧 Gráfico de Pizza</SelectItem>
            </SelectContent>
          </Select>
        </div>

        <div>
          <Label>Fonte de Dados *</Label>
          <Select value={widget.dataSource} onValueChange={(v) => setWidget({ ...widget, dataSource: v })}>
            <SelectTrigger>
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="tickets">🎫 Tickets</SelectItem>
              <SelectItem value="users">👥 Usuários</SelectItem>
              <SelectItem value="customers">🏢 Clientes</SelectItem>
              <SelectItem value="products">📦 Produtos</SelectItem>
              <SelectItem value="categories">🏷️ Categorias</SelectItem>
            </SelectContent>
          </Select>
        </div>

        <div>
          <Label>Métrica *</Label>
          <Select 
            value={widget.config.metric} 
            onValueChange={(v) => setWidget({ ...widget, config: { ...widget.config, metric: v } })}
          >
            <SelectTrigger>
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="count">Contagem</SelectItem>
              <SelectItem value="sum">Soma</SelectItem>
              <SelectItem value="avg">Média</SelectItem>
            </SelectContent>
          </Select>
        </div>

        {(widget.type === 'bar_chart' || widget.type === 'pie_chart') && (
          <div>
            <Label>Agrupar Por</Label>
            <Select 
              value={widget.config.groupBy} 
              onValueChange={(v) => setWidget({ ...widget, config: { ...widget.config, groupBy: v } })}
            >
              <SelectTrigger>
                <SelectValue placeholder="Selecione..." />
              </SelectTrigger>
              <SelectContent>
                {widget.dataSource === 'tickets' && (
                  <>
                    <SelectItem value="status">Status</SelectItem>
                    <SelectItem value="priority">Prioridade</SelectItem>
                    <SelectItem value="categoryId">Categoria</SelectItem>
                    <SelectItem value="productId">Produto</SelectItem>
                  </>
                )}
                {widget.dataSource === 'users' && (
                  <SelectItem value="companyId">Empresa</SelectItem>
                )}
              </SelectContent>
            </Select>
          </div>
        )}

        <div className="flex gap-2 pt-4 border-t">
          <Button onClick={onClose} variant="outline" className="flex-1">
            Cancelar
          </Button>
          <Button onClick={handleCreate} className="flex-1 bg-blue-600 hover:bg-blue-700">
            Criar Widget
          </Button>
        </div>
      </div>
    </Modal>
  );
}
